import firebase from "firebase";
const firebaseApp = firebase.initializeApp({
  apiKey: "AIzaSyDV5n7Hp6ST6QAnOTzd3hcPKQnHpT5Cprw",
  authDomain: "instagram-clone-b1941.firebaseapp.com",
  databaseURL: "https://instagram-clone-b1941.firebaseio.com",
  projectId: "instagram-clone-b1941",
  storageBucket: "instagram-clone-b1941.appspot.com",
  messagingSenderId: "555331670186",
  appId: "1:555331670186:web:3b3c121c976db2f23840d3",
  measurementId: "G-TF8W9NMXW7"
});

const db = firebaseApp.firestore();
const auth = firebase.auth();
const storage = firebase.storage();
export {db,auth, storage};